<div class="card-search">
  <div class="search-input-wrapper" [class.search-input-wrapper--scoped]="hasScope()">
    @if (activeScope(); as active) {
      <div class="card-search__scope">
        <button
          #scopeBadge
          type="button"
          class="card-search__scope-badge"
          aria-haspopup="listbox"
          [attr.aria-expanded]="scopeMenuOpen()"
          [attr.aria-label]="scopeAriaLabel() || null"
          (click)="toggleScopeMenu()"
        >
          @if (active.icon) {
            <span [zagIcon]="active.icon" class="card-search__scope-icon"></span>
          }
          <span class="card-search__scope-label">{{ active.label }}</span>
          <span zagIcon="expand_more" class="card-search__scope-chevron"></span>
        </button>
        @if (scopeMenuOpen()) {
          <div class="card-search__scope-menu" role="listbox" [attr.aria-label]="scopeAriaLabel() || null">
            @for (option of scopes(); track option.id) {
              <button
                type="button"
                role="option"
                class="card-search__scope-option"
                [class.card-search__scope-option--active]="isActiveScope(option)"
                [attr.aria-selected]="isActiveScope(option)"
                (click)="selectScope(option)"
              >
                @if (option.icon) {
                  <span [zagIcon]="option.icon" class="card-search__scope-option-icon"></span>
                }
                <span class="card-search__scope-option-label">{{ option.label }}</span>
                @if (isActiveScope(option)) {
                  <span zagIcon="check" class="card-search__scope-option-check"></span>
                }
              </button>
            }
          </div>
        }
      </div>
    } @else {
      <span zagIcon="search" class="search-icon"></span>
    }
    <input
      type="text"
      class="search-input"
      [placeholder]="placeholder() | translate"
      [value]="immediateSearchValue()"
      (input)="onInputChange($any($event.target).value)"
    />
    @if (immediateSearchValue()) {
      <button type="button" class="clear-button" (click)="clearSearch()" aria-label="Clear search">
        <span zagIcon="close"></span>
      </button>
    }
  </div>
</div>
